import React from 'react';

import DeviceSelector from '../DeviceSelector/DeviceSelector';

const NewController: React.FC = () => <DeviceSelector type="thermostat" />;

export default NewController;
